@import '../../sass/base/variables';

.input-error {
  color: $danger;
}